module.exports = __webpack_public_path__ + "img/logo54.3f335863.png";